import React from "react";
import { LocalForm, Control, actions } from "react-redux-form";
import { FormGroup, SaveButton } from "components/common";
import {
  compose,
  withStateHandlers,
  withHandlers,
  withPropsOnChange,
} from "recompose";
import { every, isFunction } from "lodash";
import { Modal, ModalBody, Button, ModalHeader } from "reactstrap";
import { isEmail } from "validator";
import { NotificationManager } from "react-notifications";
import { Trans } from "react-i18next";

const SendEmail = ({
  isOpen,
  toggle,
  form,
  setForm,
  onSubmit,
  onConfirm,
  setItem,
  setIsOpen,
  item,
  setDispatch,
  ...props
}) => (
  <Modal isOpen={isOpen} toggle={toggle}>
    <ModalHeader>
      <Trans>Send</Trans>
    </ModalHeader>
    <ModalBody>
      <LocalForm
        onUpdate={setForm}
        onChange={setItem}
        initialState={item}
        onSubmit={onSubmit}
        getDispatch={setDispatch}
        validators={{
          email: (v) => (!v ? true : every(v.split(";"), (y) => isEmail(y))),
          subject: (v) => !!v,
          content: (v) => !!v,
        }}
      >
        <FormGroup label="To" model=".email">
          <Control.text model=".email" />
          <span className="form-text text-muted small">
            <Trans>
              Separate multiple email addresses with a semicolon (;)
            </Trans>
          </span>
        </FormGroup>
        <FormGroup label="Subject" model=".subject">
          <Control.text model=".subject" />
        </FormGroup>
        <FormGroup label="Message" model=".content">
          <Control.textarea rows="10" model=".content" />
        </FormGroup>
        <div className="d-flex justify-content-end">
          <Button
            color="secondary"
            className="mr-2"
            onClick={() => setIsOpen(false)}
          >
            Cancel
          </Button>
          <SaveButton form={form}>Send</SaveButton>{" "}
        </div>
      </LocalForm>
    </ModalBody>
  </Modal>
);

export const enhance = compose(
  withStateHandlers(
    {},
    {
      setForm: () => (form) => ({ form }),
      setItem: () => (item) => ({ item }),
      setSettings: () => (settings) => ({ settings }),
      setDispatch: () => (dispatch) => ({ dispatch }),
    }
  ),
  withPropsOnChange(["url"], ({ url }) => ({
    url: isFunction(url) ? url : () => url,
  })),
  withHandlers({
    onSubmit: (props) => (tmpItem) => {
      const { xero, setIsOpen, url, dispatch, t } = props;
      const item = {
        ...tmpItem,
        email: tmpItem.email.split(";"),
      };
      dispatch(actions.setPending("local", true));

      return xero
        .post(url(item, props), item)
        .then(() => {
          NotificationManager.success(t("Email successfully sent"));
          setIsOpen(false);
        })
        .finally(() => dispatch(actions.setPending("local", false)));
    },
  })
);

export default enhance(SendEmail);
